'use client'

import { useEffect, useState } from 'react';
import { usePathname, useRouter } from 'next/navigation';
import { useSimpleAuth as useAuth } from '@sourcepilot/ui/shell/auth/use-simple-auth';
import { useTabData } from '@sourcepilot/ui/framework/state/session-data';
import WorkspaceContent from '@/ui/organisms/tab-contents/WorkspaceContent';

export default function Home() {
  const router = useRouter();
  const pathname = usePathname();
  const { user } = useAuth();
  const { tabs } = useTabData();
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => { setHasMounted(true); }, []);

  useEffect(() => {
    if (!hasMounted) return;

    if (!user) {
      router.push('/login');
      return;
    }

    // try to reload the latest tab
    if (tabs && tabs.length > 0) {
      const mostRecentTab = tabs.reduce((latest, item) =>
        new Date(item.viewed_at) > new Date(latest.viewed_at) ? item : latest
      ) || tabs[0];
      // Guard: don't push to a path we're already on. If the most-recent
      // tab is `/` itself (e.g. the visit to `/` got recorded as a tab),
      // pushing remounts this page → useEffect re-fires with hasMounted
      // reset → another push → 40 GET / per second loop in dev.
      if (mostRecentTab.pathname && mostRecentTab.pathname !== pathname) {
        router.push(mostRecentTab.pathname);
      }
      return;
    }
  }, [user, tabs, router, hasMounted, pathname]);

  // Server and initial client render: show workspace content (no branching on user)
  // Auth redirect happens in useEffect above
  return <WorkspaceContent />;
}

